import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../hooks/useSubscription';

export default function ProGate({ children, feature = "questa funzionalità", inline = false }) {
  const { isPro, loading } = useSubscription();
  const navigate = useNavigate();

  if (loading) return null;
  if (isPro) return children;

  if (inline) {
    return (
      <div style={{position:'relative',display:'inline-block'}}>
        <div style={{opacity:0.4,pointerEvents:'none'}}>{children}</div>
        <div onClick={()=>navigate('/abbonamento')} style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',borderRadius:9999,background:'rgba(13,11,30,0.8)'}} title="Funzionalità PRO">
          <span style={{fontSize:'0.72rem',color:'#a78bfa',fontWeight:700}}>🔒 PRO</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{position:'relative',minHeight:200}}>
      <div style={{filter:'blur(3px)',opacity:0.25,pointerEvents:'none',overflow:'hidden',maxHeight:300}}>{children}</div>
      <div style={{position:'fixed',inset:0,display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
        <div style={{textAlign:'center',background:'rgba(13,11,30,0.98)',border:'1px solid #7c3aed',borderRadius:24,padding:'32px 40px',maxWidth:380,position:'relative',boxShadow:'0 0 60px rgba(124,58,237,0.4)'}}>
          <button onClick={()=>navigate(-1)} style={{position:'absolute',top:12,right:12,background:'none',border:'none',color:'#6b7280',fontSize:'1.2rem',cursor:'pointer',padding:4,lineHeight:1}} title="Chiudi">✕</button>
          <div style={{fontSize:'2.5rem',marginBottom:12}}>🔒</div>
          <h3 style={{fontFamily:'Syne,sans-serif',fontSize:'1.1rem',fontWeight:800,color:'#e2e8f0',marginBottom:8}}>Funzionalità PRO</h3>
          <p style={{fontSize:'0.85rem',color:'#6b7280',marginBottom:20,lineHeight:1.6}}>Sblocca {feature} con il piano PRO</p>
          <button onClick={()=>navigate('/abbonamento')} style={{background:'linear-gradient(135deg,#7c3aed,#4f46e5)',color:'white',border:'none',borderRadius:9999,padding:'12px 28px',fontFamily:'DM Sans,sans-serif',fontWeight:700,fontSize:'0.9rem',cursor:'pointer',width:'100%',boxShadow:'0 4px 16px rgba(124,58,237,0.4)'}}>
            ⭐ Upgrade a PRO
          </button>
        </div>
      </div>
    </div>
  );
}
